const apiClient = require('@/api/client.js')

var Session = {

  state: {
    user: JSON.parse(getLocalStorageItem('user')) || {},
    company: JSON.parse(getLocalStorageItem('company')) || null,
    access_token: getLocalStorageItem('access_token') || null,
    api_key: getLocalStorageItem('api_key') || null
  },

  setUser(user){
    this.state.user = user;
    putLocalStorageItem('user', JSON.stringify(user))
  },

  getUser(){
    return this.state.user
  },

  setCompany(company){
    this.state.company = company;
    putLocalStorageItem('company', JSON.stringify(company))
  },

  getCompany(){
    return this.state.company
  },

  setAccessToken(access_token){
    this.state.access_token = access_token;
    putLocalStorageItem('access_token', access_token)
  },

  getAccessToken(){
    return this.state.access_token
  },

  isAuthenticated(){
    return this.getAccessToken();
  },

  setApiKey(api_key){
    this.state.api_key = api_key;
    putLocalStorageItem('api_key', api_key)
  },

  getApiKey(){
    return this.state.api_key
  }

}

function getLocalStorageItem(key){
  let data = null;
  try {
    data = localStorage.getItem(key);
  }catch (e){
  }
  return data;
}

function putLocalStorageItem(key, value){
  let data = null;
  try {
    data = localStorage.setItem(key, value);
  }catch (e){
  }
  return data;
}

export default Session



// WEBPACK FOOTER //
// ./src/session/service.js